import { useBreakpoints as _useBreakpoints, breakpointsTailwind } from '@vueuse/core'

export const useBreakpoints = () => {
  return _useBreakpoints(breakpointsTailwind)
}
